import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent } from '@mui/material';
import ProductGrid from '../components/ProductGrid';

const About: React.FC = () => {
  return (
    <Box>
      {/* Full-width header image */}
      <Box
        component="img"
        src="https://smallsite-blw-static.s3.us-east-2.amazonaws.com/blw-static/blw2-2.jpg" // Replace with your image path or hosted URL
        alt="Boston Laser Works Banner"
        sx={{
          width: '100%',
          height: { xs: 250, md: 400 },
          objectFit: 'cover',
        }}
      />

      {/* Main About Content */}
      <Container maxWidth="md" sx={{ my: 6 }}>
        <Typography variant="h3" align="center" gutterBottom>
          About Boston Laser Works
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 4 }}>
          Based in the heart of New England, Boston Laser Works creates custom-designed laser-engraved goods ranging from coasters to wall art. Every item is handcrafted with precision and passion.
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>Our Story</Typography>
                <Typography variant="body2">
                  Boston Laser Works started in a small garage with a single laser cutter and a love for detail. We've grown through our commitment to quality, creativity, and customer satisfaction.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h5" gutterBottom>Our Values</Typography>
                <Typography variant="body2">
                  We believe in sustainable sourcing, supporting local suppliers, and crafting products that our customers will treasure. Every piece is made-to-order with care.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <ProductGrid />
    </Box>
  );
};

export default About;

